
import { css } from 'lit';
export default css`
:host{
  --tag-bg-override:var(--primary-white);
  --wysiwyg-font-color:var(--primary-eggplant);
}

.insight-series{
  background-color:var(--neutral-light);
}

.inner{
  display:grid;
  gap:1rem;
  padding:var(--grid-spacing-y) 0;
}

@media (min-width: 992px){

.inner{
    grid-template-columns:1fr 1fr
}
  }

.content{
  display:grid;
  gap:1rem;
}

::slotted([slot='cta']){
  display:grid;
  margin-top:1rem;
}

@media (min-width: 992px){

::slotted([slot='cta']){
    display:inline
}
  }
`;